import { render, staticRenderFns } from "./ModelManage.vue?vue&type=template&id=32f40c8a&scoped=true"
import script from "./ModelManage.vue?vue&type=script&lang=js"
export * from "./ModelManage.vue?vue&type=script&lang=js"
import style0 from "./ModelManage.vue?vue&type=style&index=0&id=32f40c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f40c8a",
  null
  
)

export default component.exports